export default __webpack_public_path__ + "static/assets/6bf6727dcf2ed5f49297c98f817a9f82.png";